export const config = Object({

    //Local
    // apiHostClient: 'http://',
    // apiURL: 'localhost:62683',
    
    //UAT
    // apiHostClient: 'https://',
    // apiURL: 'dev-booking.motorforum.no/PlannerAPI',
            
    //Prod
    apiHostClient: 'https://',
    apiURL: 'booking.motorforum.no/PlannerAPI',

    apiHostVersion: '/api/',
    // apiURL: '192.168.10.168',


    redirectURL : 'https://www.motorforum.no/bestill-time',
    username: 'WHaSQkORXebh7ASjmxyoxA==',
    password: 'zSnCh4vPA emC5lAswPqaQ==',
    domainName: 'localhost:4200'
});
